// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.termsandconditions.RentalManagerUserTermsAndConditionsWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserTermsAndConditionsMarkAcceptedTermsRequestWebDto,
  UserTermsAndConditionsMarkAcceptedTermsResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms_Args {
  postData: UserTermsAndConditionsMarkAcceptedTermsRequestWebDto;
}

export type RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms_Options = UseMutationOptions<
  UserTermsAndConditionsMarkAcceptedTermsResponseWebDto,
  unknown,
  RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms_Args
>;

/**
 * Mark terms and conditions as accepted
 */
export const useRentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms_Args) =>
      RentalManagerUserTermsAndConditionsWebApiHandler_markAcceptedTerms(args.postData, httpClient),
  });
};
